<template>
    <v-data-table
        :headers='headers'
        :items='type.designAssumptions'
        :items-per-page="10"
        item-key='name'
    >
    </v-data-table>
</template>

<script>
export default {
    props:{
        type: Object
    },
    data () {
        return {
            headers: [
                { text: 'Name', value: 'name'},
                { text: 'Value', value: 'value'},
            ]
        }
    }
}
</script>